import { all, call, put, takeEvery } from '@redux-saga/core/effects';

import * as actions from '@actions/transactionTypes';
import { getTransactionsList } from '@api/transactionTypes';
import {
  GET_TRANSACTIONS_TYPES_REQUEST,
  SAVE_CLIENT_TAX_CODES_MANUAL,
  SAVE_CLIENT_TAX_CODES_MANUAL_RATES,
} from '@constants/action-types/transactionTypes';
import { NOTIFICATION_TYPES } from '@constants/notifications';
import { intl } from '@helpers/intl';
import { setNotifications } from '@store/notifications';

export const handleGetTransactionTypes = function* ({ payload }) {
  try {
    const response = yield call(getTransactionsList, payload);
    yield put(actions.getTransactionTypesSuccess(response));
  } catch (e) {
    yield put(
      setNotifications('appNotifications', [
        {
          id: 'get-transaction-types-error',
          type: NOTIFICATION_TYPES.ERROR,
          message: intl.formatMessage({
            id: 'global.notification.api-error-default',
            defaultMessage: 'An unexpected error occurred, please try again.',
          }),
        },
      ])
    );
    yield put(actions.getTransactionTypesFailure(e));
  }
};

export const handleSaveSelectedTaxCodes = function* (payload) {
  try {
    yield put(actions.saveSelectedClientTaxCodesSuccess(payload.response));
  } catch (e) {
    yield put(actions.saveSelectedClientTaxCodesFailure(e));
  }
};

export const handleSaveSelectedTaxCodesRates = function* (payload) {
  try {
    yield put(actions.saveClientTaxCodeRatesSuccess(payload.response));
  } catch (e) {
    yield put(actions.saveClientTaxCodeRatesFailure(e));
  }
};

export default all([
  takeEvery(GET_TRANSACTIONS_TYPES_REQUEST, handleGetTransactionTypes),
  takeEvery(SAVE_CLIENT_TAX_CODES_MANUAL, handleSaveSelectedTaxCodes),
  takeEvery(SAVE_CLIENT_TAX_CODES_MANUAL_RATES, handleSaveSelectedTaxCodesRates),
]);
